module.exports = __webpack_public_path__ + "img/submit-h.cec3b1b2.png";